import { FileItemProps } from '@components/Core/Folders/FileItem/FileItem.component';

export const FOLDER_SEPARATOR: string = '/';

export type FileTransaction = {
  sourcePath: FileItemProps;
  file: FileItemProps;
  newFile?: FileItemProps;
  paths: string[];
  targetPaths: string[];
};

export const replaceFileFromCurrentPath = (
  sourcePath: FileItemProps,
  newFile: FileItemProps,
  paths: string[],
  oldFile: FileItemProps
): FileItemProps => {
  let files = findFile(sourcePath, paths);
  const replaceFileMap = (file: FileItemProps): FileItemProps => {
    if (file.id === oldFile.id) {
      return {
        ...newFile,
        ...(oldFile?.type === 'folder' && { files: oldFile.files }),
      };
    }

    return file;
  };
  files.files = files.files.map(replaceFileMap);

  return sourcePath;
};

export const updateFileData = (
  sourcePath: FileItemProps,
  updates: FileItemProps,
  paths: string[],
  oldFile: FileItemProps
): FileItemProps => {
  let files = findFile(sourcePath, paths);
  const replaceFileMap = (file: FileItemProps): FileItemProps => {
    if (file.id === oldFile.id) {
      return { ...file, ...updates };
    }

    return file;
  };
  files.files = files.files.map(replaceFileMap);

  return sourcePath;
};

export const removeFileFromCurrentPath = (
  sourcePath: FileItemProps,
  file: FileItemProps,
  paths: string[]
): FileItemProps => {
  let files = findFile(sourcePath, paths);
  files.files = files.files.filter(({ id }) => id !== file.id);

  return sourcePath;
};

export const addFileToCurrentPath = (
  sourcePath: FileItemProps,
  file: FileItemProps,
  paths: string[]
): FileItemProps => {
  let files = findFile(sourcePath, paths);
  files.files = [...files.files, file];
  return sourcePath;
};

export const encodeFileName = (name: string): string => {
  return encodeURIComponent(name);
};

export const decodeFileName = (name: string): string => {
  return decodeURIComponent(name);
};

export const findFile = (sourcePath: FileItemProps, pathList: string[]) => {
  if (pathList.length === 0) {
    return sourcePath;
  }

  console.log('pathList', pathList);
  console.log('sourcePath', sourcePath);

  pathList?.forEach(folder => {
    if (
      sourcePath &&
      sourcePath.name &&
      sourcePath.name !== decodeFileName(folder)
    ) {
      sourcePath = sourcePath.files?.find(
        ({ name }) => name === decodeFileName(folder)
      ) as FileItemProps;
    }
  });

  return sourcePath;
};

export const getFolder = (
  sourcePath: FileItemProps | FileItemProps[],
  pathList: string[]
) => {
  if (pathList.length === 0) {
    return sourcePath;
  }
  let previousPath;

  pathList.forEach(folder => {
    if (Array.isArray(sourcePath)) {
      previousPath = sourcePath.find(
        ({ name }) => name === decodeFileName(folder)
      ) as FileItemProps;
    } else {
      previousPath = sourcePath.files.find(
        ({ name }) => name === decodeFileName(folder)
      ) as FileItemProps;
    }

    if (previousPath && previousPath.type === 'folder') {
      sourcePath = previousPath;
    }
  });

  return sourcePath;
};

export const moveFileToTargetPath = (
  transaction: FileTransaction
): FileItemProps => {
  const { file, paths, targetPaths } = transaction;
  transaction.sourcePath = removeFileFromCurrentPath(
    transaction.sourcePath,
    { ...file, htmlName: file.name },
    paths
  );
  transaction.sourcePath = addFileToCurrentPath(
    transaction.sourcePath,
    { ...file, htmlName: file.name },
    targetPaths
  );
  return transaction.sourcePath;
};

export const renameFileWithTransaction = (
  transaction: FileTransaction
): FileItemProps => {
  const { file, newFile = {} as FileItemProps } = transaction;
  const currentFile = findFileById(file, transaction.sourcePath.files);
  const newFiles = replaceFileFromCurrentPath(
    transaction.sourcePath,
    newFile,
    currentFile.path?.split(FOLDER_SEPARATOR).filter(item => item.length > 0) ??
      [],
    currentFile
  );
  return newFiles;
};

export const updateFileWithTransaction = (
  transaction: FileTransaction
): FileItemProps => {
  const { file, newFile = {} as FileItemProps } = transaction;
  const currentFile = findFileById(file, transaction.sourcePath.files);
  const newFiles = updateFileData(
    transaction.sourcePath,
    newFile,
    currentFile.path?.split(FOLDER_SEPARATOR).filter(item => item.length > 0) ??
      [],
    currentFile
  );
  return newFiles;
};

export const findFileByText = (
  text: string,
  sourcePath: FileItemProps[]
): FileItemProps => {
  const file = {
    id: 'search_results',
    name: 'search_results',
    files: [] as FileItemProps[],
  } as FileItemProps;
  sourcePath.forEach(fileItem => {
    searchInTree(text, fileItem, file);
  });
  return file;
};

export const findFileById = (
  file: FileItemProps,
  sourcePath: FileItemProps[]
): FileItemProps => {
  const path = '/';
  const orders: any = {
    list: [],
  };
  sourcePath.forEach(fileItem => {
    searchInTreeById(file as FileItemProps, fileItem, `${path}`, orders);
  });
  return { ...file, path: orders.path };
};

const searchInTree = (
  text: string,
  file: FileItemProps,
  resultFile: FileItemProps
) => {
  if (file.name.toLowerCase().includes(text.toLowerCase())) {
    resultFile.files = [...resultFile.files, file];
  }

  if (file.type === 'folder') {
    file?.files?.forEach(fileItem => {
      searchInTree(text, fileItem, resultFile);
    });
  }
};

const searchInTreeById = (
  file: FileItemProps,
  currentFile: FileItemProps,
  path: string,
  orders: any
) => {
  if (file.id === currentFile.id) {
    orders.path = path;
    return;
  }

  if (currentFile.type === 'folder') {
    currentFile?.files?.forEach(fileItem => {
      searchInTreeById(
        file,
        fileItem,
        `${path}${currentFile.name}${FOLDER_SEPARATOR}`,
        orders
      );
    });
  }
};
